<!-- <div class="py-4 top-wrap">
    <div class="    container-xl">
        <div class="row d-flex align-items-start">

            <div class="col-md topper d-flex mb-md-0 align-items-xl-center">
                <div class="icon d-flex justify-content-center align-items-center"><span class="fa fa-map"></span>
                </div>
                <div class="text pl-3 pl-md-3">
                    <p class="con"><span>Free Call</span> <span>+1 234 456 78910</span></p>
                    <p class="con">Call Us Now 24/7 Customer Support</p>
                </div>
            </div>

            <div class="col-md topper d-flex mb-md-0 align-items-xl-center">
                <div class="icon d-flex justify-content-center align-items-center"><span class="fa fa-paper-plane"></span>
                </div>
                <div class="text pl-3 pl-md-3">
                    <p class="hr"><span>Our Location</span></p>
                    <p class="con">Suite 721 New York NY 10016</p>
                </div>
            </div>

            <div class="col-md topper d-flex mb-md-0 align-items-xl-center">
                <div class="icon d-flex justify-content-center align-items-center"><span class="fa fa-connectdevelop"></span>
                </div>
                <div class="text pl-3 pl-md-3">
                    <p class="con"><span>Connect </span> <span>with us</span></p>
                    <p class="con"><a href="">Facebook</a> <a href="">Twitter</a> <a href="">Dribbble</a></p>
                </div>
            </div>
        </div>
    </div>
</div> -->
<nav class="navbar navbar-expand-lg white-menu">
    <div class="container-xl">
        <a class="navbar-brand align-items-center" href="">
            <img src="https://d3om06iw6o6an5.cloudfront.net/logo/direkt-black-logo-only.png" class="logo">
            <span class="tagline">Where Properties Speak Direktly!</span>
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <span class="fa fa-bars"></span> Menu
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">

                <li class="nav-item">
                    <a class="nav-link"
                        href="https://api.whatsapp.com/send?phone=971563584795&text=Hello%20I%20need%20information%20about%20properties."
                        target="_blank">
                        Post your requirement
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)" (click)="onSubmit()">Submit A Property</a>
                </li>

                <li class="nav-item" *ngIf="!shared.isUserLoggedIn">
                    <a class="nav-link" href="javascript:void(0)" (click)="openSignUp()">Sign Up</a>
                </li>

                <li class="nav-item" *ngIf="!shared.isUserLoggedIn">
                    <a class="nav-link" href="javascript:void(0)" (click)="onSubmit()">Login</a>
                </li>

                <!-- <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="dropdownMenuButton1"
                        data-bs-toggle="dropdown">
                        Plans
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="/subscription-owner-plan">Owner Plans</a></li>
                        <li><a class="dropdown-item" href="/subscription-buyer-plan">Buyer Plans</a></li>
                        <li><a class="dropdown-item" href="/subscription-tenant-plan">Tenant Plans</a></li>
                    </ul>
                </li> -->

                <li class="nav-item dropdown" *ngIf="shared.isUserLoggedIn">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-bs-toggle="dropdown">
                        {{shared.userData.nameInitial}}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><a class="dropdown-item" href="/my-property-list">My Properties</a></li>
                        <li><a class="dropdown-item" href="/favourite-list">Favourite Properties</a></li>
                        <li><a class="dropdown-item" href="/contacted-properties">Contacted Properties</a></li>
                        <li><a class="dropdown-item" href="/subscription-list">Subscription</a></li>
                        <li><a class="dropdown-item" href="/inquiry-list">Inquiries</a></li>
                        <li><a class="dropdown-item" href="/profile-view">Profile</a></li>
                        <div class="dropdown-divider"></div>
                        <li><a class="dropdown-item" href="/change-password">Change password</a></li>
                        <li><a class="dropdown-item" (click)="logout()" href="javascript:void(0)">Logout</a></li>
                    </ul>
                </li>

            </ul>
        </div>
    </div>
</nav>


<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header mt-3">
                <h5 class="modal-title title" id="exampleModalLongTitle">
                    Mortgages
                </h5>
                <button type="button" class="btn btn-primary close mb-1" data-dismiss="modal" (click)="onCloseModal('mortgages')">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="!isSubmitted">
                    <div *ngIf="message" class="alert alert-warning mb-3">
                        {{ message }}
                    </div>

                    <form id="mortgagesForm" [formGroup]="mortgagesForm" name="mortgagesForm" class="mortgagesForm"
                        method="POST">
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Name:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="name">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Mobile:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="mobile">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Occupation:</label>
                            </div>
                            <div class="col-9">
                                <div class="wall_radio">
                                    <input class="" type="radio" formControlName="occupation" value='1'>
                                    Salaried
                                    <input class="" type="radio" formControlName="occupation" value='2'>
                                    Self Employed
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">DOB:</label>
                            </div>
                            <div class="col-9">
                                <input type="date" class="form-control" formControlName="dob">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Emirate:</label>
                            </div>
                            <div class="col-9">
                                <select class="form-control" formControlName="emirates">
                                    <option>Please select</option>
                                    <option *ngFor="let e of emirates" [attr.id]="e.id">{{e.city}}</option>
                                </select>
                            </div>
                        </div>
                        
                        <!-- <div class="row d-flex justify-content-center">
                            <div class="col-6">
                                <div class="my-4">
                                    <div class="g-recaptcha"
                                        data-sitekey="6LchOyEUAAAAAPo9l0WmIgFkGu5D6Gyq-MjsIHS1"></div>
                                </div>
                            </div>
                        </div> -->

                        

                        <div class="modal-footer" *ngIf="!isSubmitted">
                            <button type="button" class="btn btn-primary" (click)="onClick()">Submit</button>
                        </div>
                    </form>
                </div>

                <ng-container *ngIf="isSubmitted">
                    <div class="alert alert-success mt-3">
                        {{ message }}
                    </div>
                </ng-container>

            </div>

                
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
                <h5 class="modal-title title" id="exampleModalLongTitle">
                    Document Assistant
                </h5>
                <button type="button" class="btn btn-primary close mb-1" data-dismiss="modal">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <form id="documentassistantForm" [formGroup]="documentassistantForm" name="documentassistantForm"
                    class="documentassistantForm" method="POST">
                    <div class="row mb-2">
                        <div class="col-3">
                            <label for="nameInput" class="form-label">Name:</label>
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" formControlName="name">
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">
                            <label for="nameInput" class="form-label">Mobile:</label>
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" formControlName="mobile">
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">
                            <label for="nameInput" class="form-label">Email:</label>
                        </div>
                        <div class="col-9">
                            <input type="email" class="form-control" formControlName="email">
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">
                            <label for="nameInput" class="form-label">Assistant For:</label>
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" formControlName="assistant_for">
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="onClear()">Submit</button>
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade" id="signupModal" tabindex="-1" role="dialog" data-bs-backdrop="static"> -->
    <div class="modal fade" id="signupModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
                <h5 class="modal-title title" >
                    Sign Up
                </h5>
                <button type="button" class="btn btn-primary close mb-1" (click)="onSignUpClose()" >
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body" >
                <!-- <app-signup [showContactInfo]="false"></app-signup> -->
                <app-signup-modal ></app-signup-modal>
            </div>
    </div>
    </div>
</div>

<div class="modal fade" id="evaluationModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
            <h5 class="modal-title title" id="exampleModalLongTitle">
                Property Value Approximation
            </h5>
                <button type="button" class="btn btn-primary close mb-1" data-dismiss="modal" (click)="closeEvaluationModal()">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">

                <div *ngIf="isApproximationFormSubmit" class="alert alert-success mt-3">
                    will get in touch with you soon.
                </div>

                <form *ngIf="!isApproximationFormSubmit" id="propertyvalueapproximationForm" [formGroup]="propertyvalueapproximationForm" name="propertyvalueapproximationForm"
                class="propertyvalueapproximationForm" method="POST">

                <div *ngIf="approximationFormMessage" class="alert alert-warning mb-2">
                    {{ approximationFormMessage }}
                </div>

                <div class="row mb-2">
                    <div class="col-4">
                        <label for="imageInput" class="form-label">Clear photos of all areas:</label>
                    </div>
                    <div class="col-8">
                        <!-- <input type="file" class="form-control" id="imageInput" accept="image/*" formControlName="area"> -->
                        <input formControlName="area" style="display: none" type="file" #areaFileInput
                            (change)="onFileChange($event,'area')" multiple />
                        <button type="button" class="btn btn-primary" (click)="areaFileInput.click()">Add Photos</button>
                        <div *ngIf="areaImages.length > 0">
                            <div class="row mt-2">
                                <ng-container *ngFor="let image of areaImages; let i = index">
                                    <div class="col-4">
                                        <div class="row">
                                            <img [src]="image" alt="Entrance Image" width="50px" height="50px" />
                                            <div class="delete-div mt-1">
                                                <button type="button" class="btn btn-danger" style="line-height: 0px;"
                                                    (click)="deleteImage(i,'area')"><i style="font-size:18px" class="fa">&#xf1f8;</i><br>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="imageInput" class="form-label">Title Deed:</label>
                    </div>
                    <div class="col-8">
                        <!-- <input type="file" class="form-control" id="imageInput" accept="image/*" formControlName="title_deed"> -->
                        <input formControlName="title_deed" style="display: none" type="file" #titleDeedFileInput
                            (change)="onFileChange($event,'title_deed')" multiple />
                        <button type="button" class="btn btn-primary" (click)="titleDeedFileInput.click()">Add Photos</button>
                        <div *ngIf="titleDeedImages.length > 0">
                            <div class="row mt-2">
                                <ng-container *ngFor="let image of titleDeedImages; let i = index">
                                    <div class="col-4">
                                        <div class="row">
                                            <img [src]="image" alt="Entrance Image" width="100" height="100" />
                                            <div class="delete-div mt-1">
                                                <button type="button" class="btn btn-danger" style="line-height: 0px;"
                                                    (click)="deleteImage(i,'title_deed')"><i style="font-size:18px" class="fa">&#xf1f8;</i><br>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">Floor Plan:</label>
                    </div>
                    <div class="col-8">
                        <!-- <input type="file" class="form-control" id="imageInput" accept="image/*" formControlName="floor_plan"> -->
                        <input formControlName="floor_plan" style="display: none" type="file" #titleDeedFileInput
                            (change)="onFileChange($event,'floor_plan')" multiple />
                        <button type="button" class="btn btn-primary" (click)="titleDeedFileInput.click()">Add Photos</button>
                        <div *ngIf="floorPlanImages.length > 0">
                            <div class="row mt-2">
                                <ng-container *ngFor="let image of floorPlanImages; let i = index">
                                    <div class="col-4">
                                        <div class="row">
                                            <img [src]="image" alt="Entrance Image" width="100" height="100" />
                                            <div class="delete-div mt-1">
                                                <button type="button" class="btn btn-danger" style="line-height: 0px;"
                                                    (click)="deleteImage(i,'title_deed')"><i style="font-size:18px" class="fa">&#xf1f8;</i><br>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">A description of the views:</label>
                    </div>
                    <div class="col-8">
                        <textarea class="form-control" id="descriptionInput" formControlName="description_Views"></textarea>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">Details if any modifications have been done (upgradations):</label>
                    </div>
                    <div class="col-8">
                        <textarea class="form-control" id="upgradations" formControlName="upgradations"></textarea>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">Contact Number:</label>
                    </div>
                    <div class="col-8">
                        <input type="text" class="form-control" formControlName="contact_number">
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">Owners Name:</label>
                    </div>
                    <div class="col-8">
                        <input type="text" class="form-control" formControlName="owners_name">
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-4">
                        <label for="nameInput" class="form-label">Address of property:</label>
                    </div>
                    <div class="col-8">
                        <input type="text" class="form-control" formControlName="address_of_property">
                    </div>
                </div>
            </form>
               
            </div>
            <div class="modal-footer" *ngIf="!isApproximationFormSubmit">
                <button type="button" class="btn btn-primary" (click)="onDone()">Submit</button>
            </div>
        </div>
    </div>
</div>